import { enableMachineProductionEvents } from "@/common/config";

export default [
  {
    path: "/machine",
    name: "machine_map_overview",
    component: () =>
      import(
        /* webpackChunkName: "MachineMapOverview" */ /* webpackPrefetch: true */ "@/views/MachineFleetOverview.vue"
      ),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/machine/timelines",
    name: "machine_timelines",
    component: () => import(/* webpackChunkName: "MachineTimelines" */ "@/views/MachineTimelines"),
    meta: {
      requiresAuth: true,
      layout: "page-fullscreen-layout"
    }
  },
  {
    path: "/machine/:id",
    redirect: { name: "machine_overview" }
  },
  {
    path: "/machine/:id/overview",
    name: "machine_overview",
    component: () =>
      import(/* webpackChunkName: "MachineOverview" */ "@/views/MachineOverview.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-dashboard.png"),
      showMachineHeader: true,
      freeTrialEnabled: true
    }
  },
  {
    path: "/machine/:id/data",
    name: "machine_data",
    component: () => import(/* webpackChunkName: "MachineData" */ "@/views/MachineData.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-machine_data.png"),
      showMachineHeader: true
    }
  },
  // {
  //   path: "/machine/:id/user-messages",
  //   name: "machine_messages",
  //   component: () =>
  //     import(/* webpackChunkName: "MachineMessages" */ "@/views/MachineMessages.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     sidebar: "machine",
  //     addPageWithinSidebar: true,
  //     ico: "menu-machine_messages.png",
  //     setSelectedGroupMachines: true
  //   }
  // },
  {
    path: "/machine/:id/tooling",
    name: "machine_tooling",
    component: () => import(/* webpackChunkName: "MachineTooling" */ "@/views/MachineTooling.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-machine_tooling.png"),
      machineFamilyExcluded: ["TFO", "AWJ", "AUT", "EBA", "SEZ"],
      setSelectedGroupMachines: true,
      showMachineHeader: true
    }
  },
  {
    path: "/machine/:id/tooling/:toolId",
    name: "machine_tooling_2",
    component: () => import(/* webpackChunkName: "MachineTooling" */ "@/views/MachineTooling.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: false,
      ico: require("@/assets/images/menu-machine_tooling.png"),
      machineFamilyExcluded: ["TFO", "AWJ", "AUT", "EBA", "SEZ"],
      setSelectedGroupMachines: true,
      showMachineHeader: true
    }
  },
  {
    path: "/machine/:id/dashboard",
    name: "machine_dashboard",
    component: () =>
      import(/* webpackChunkName: "MachineDashboard" */ "@/views/MachineDashboard.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      //addPageWithinSidebar: true, //remove from sidebar
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-dashboard.png"),
      showMachineHeader: true
    }
  },
  {
    path: "/machine/:id/status",
    name: "machine_status",
    component: () => import(/* webpackChunkName: "MachineStatus" */ "@/views/MachineStatus.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-status.png"),
      showMachineHeader: true,
      freeTrialEnabled: true
    }
  },
  {
    path: "/machine/:id/production",
    name: "machine_production",
    component: enableMachineProductionEvents
      ? () =>
          import(/* webpackChunkName: "MachineProduction" */ "@/views/MachineProductionEvents.vue")
      : () => import(/* webpackChunkName: "MachineProduction" */ "@/views/MachineProduction.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-production.png"),
      showMachineHeader: true,
      freeTrialEnabled: true
    }
  },
  {
    path: "/machine/:id/alarms",
    name: "machine_alarms",
    component: () => import(/* webpackChunkName: "MachineAlarms" */ "@/views/MachineAlarms.vue"),
    meta: {
      requiresAuth: true,
      setSelectedGroupMachines: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-alarm.png"),
      showMachineHeader: true,
      freeTrialEnabled: true
    }
  },
  {
    path: "/machine/:id/environmental-sensors",
    name: "environmental_sensors",
    component: () =>
      import(/* webpackChunkName: "MachineAlarms" */ "@/views/EnvironmentalSensors.vue"),
    meta: {
      requiresAuth: true,
      setSelectedGroupMachines: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-machine_components.png"),
      showMachineHeader: true,
      freeTrialEnabled: true,
      onlyForSensorIm: true
    }
  },
  {
    path: "/machine/:id/components",
    name: "machine_family",
    component: () => import(/* webpackChunkName: "MachineFamily" */ "@/views/MachineFamily.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "machine",
      addPageWithinSidebar: true,
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-machine_components.png"),
      showMachineHeader: true
    }
  },
  {
    path: "/maintenance/overview",
    name: "maintenance_overview",
    component: () =>
      import(/* webpackChunkName: "Maintenance" */ "@/views/MaintenanceActivities.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      setSelectedGroupMachines: true,
      ico: require("@/assets/images/menu-overview.png")
    }
  },
  {
    path: "/maintenance/view/:maintenanceId",
    name: "maintenance_view",
    component: () =>
      import(/* webpackChunkName: "MaintenanceView" */ "@/views/MaintenanceActivityView"),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: false,
      ico: false,
      disableSearchMachineAndGroup: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "maintainer" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/maintenance/view/:maintenanceId/document/:documentId",
    name: "maintenance_document",
    component: () =>
      import(/* webpackChunkName: "MaintenanceDocument" */ "@/views/MaintenanceDocumentView"),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: false,
      ico: false,
      disableSearchMachineAndGroup: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "maintainer" },
        { Label: "admin" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      layout: "empty-layout"
    }
  },
  {
    path: "/maintenance/todo-list",
    name: "maintenance_todo",
    component: () =>
      import(/* webpackChunkName: "MaintenanceToDo" */ "@/views/MyMaintenanceActivities.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true,
      ico: require("@/assets/images/menu-todolist.png"),
      requiresRoles: [
        { Label: "maintainer" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/maintenance/todo-list/:myTodoId",
    name: "maintenance_todo_view",
    component: () =>
      import(
        /* webpackChunkName: "MyMaintenanceActivities" */ "@/views/MyMaintenanceActivities.vue"
      ),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: false,
      requiresRoles: [
        { Label: "maintainer" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/maintenance/tickets",
    name: "maintenance_tickets",
    component: () =>
      import(
        /* webpackChunkName: "MaintenanceTicketsCards" */ "@/views/MaintenanceTicketsCards.vue"
      ),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true,
      ico: require("@/assets/images/menu-maintenance_tickets.png"),
      forceRequiresRoleOverIsAdmin: true,
      requiredOrganizationType: ["VENDOR", "CUSTOMER"],
      requiresRoles: [
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "ticket_manager" },
        { Label: "digital_service_manager" },
        { Label: "vendor_user" }
      ]
    }
  },
  {
    path: "/maintenance/schedule",
    name: "maintenance_schedule",
    component: () =>
      import(/* webpackChunkName: "MaintenanceScheduled" */ "@/views/MaintenanceScheduled"),
    meta: {
      requiresAuth: true,
      sidebar: "maintenance",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-maintenance_schedule.png"),
      setSelectedGroupMachines: true,
      requiresRoles: [
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/analytics",
    name: "analytics",
    component: () => import(/* webpackChunkName: "Analytics" */ "@/views/Analytics.vue"),
    meta: {
      requiresAuth: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/analytics/machine/:id/overview",
    name: "analytics_machine_overview",
    component: () =>
      import(/* webpackChunkName: "Analytics" */ "@/views/AnalyticsMachineOverview.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "analytics",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-overview.png"),
      showAnalyticsMachineHeader: true,
      setSelectedGroupMachines: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/analytics/machine/:id/log",
    name: "machine_log",
    component: () => import(/* webpackChunkName: "Analytics" */ "@/views/MachineLog.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "analytics",
      addPageWithinSidebar: true,
      ico: require("@/assets/images/menu-overview.png"),
      showAnalyticsMachineHeader: true,
      setSelectedGroupMachines: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "manager_manutenzione" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/settings/calendar",
    name: "machine_calendar",
    component: () => import(/* webpackChunkName: "Settings" */ "@/views/MachineCalendar.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_calendar.png"),
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "vendor_user" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/calendar/:id/edit",
    name: "machine_calendar_edit",
    component: () => import(/* webpackChunkName: "Settings" */ "@/views/MachineCalendarEdit.vue"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: false,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "vendor_user" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  }
];
